import { Avatar } from 'antd'
import { useState } from 'react'
import { InView } from 'react-intersection-observer'
import cn from 'classnames'
import s from './s.module.css'

type Props = {
  iconSrc?: string
  iconBadgeSrc?: string
  code: string
  iconSize?: number
  lazy?: boolean
}

function ImageContent({ iconBadgeSrc, iconSize, iconSrc, code }: Omit<Props, 'lazy'>) {
  const [isLoaded, setLoaded] = useState(false)
  const [isError, setError] = useState(false)

  const shouldShowPlaceholder = !iconSrc || !isLoaded || isError

  return (
    <>
      {shouldShowPlaceholder && (
        <Avatar size={iconSize} className={s.icon}>
          {code.charAt(0)}
        </Avatar>
      )}
      <div className={cn(s.iconWrap, { [s.hidden]: shouldShowPlaceholder })}>
        <img
          src={iconSrc}
          alt={code}
          className={s.icon}
          style={{ width: iconSize }}
          onError={() => setError(true)}
          onLoad={() => setLoaded(true)}
        />
        {iconBadgeSrc ? <img src={iconBadgeSrc} alt={code} className={s.iconBadge} /> : null}
      </div>
    </>
  )
}

export default function Icon({ lazy, ...imageProps }: Props) {
  if (!lazy) {
    return <ImageContent {...imageProps} key={imageProps.code} />
  }

  return (
    <InView triggerOnce>
      {({ inView, ref }) => (
        <div className={s.wrap} ref={ref}>
          {inView && <ImageContent {...imageProps} />}
        </div>
      )}
    </InView>
  )
}
